/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type GetCreditHistoryParams = {
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
categories?: string[];
entry_types?: string[];
actor_user_ids?: string[];
exclude_categories?: string[];
exclude_entry_types?: string[];
exclude_actor_user_ids?: string[];
occurred_from?: string | null;
occurred_to?: string | null;
direction?: string | null;
sort?: string;
/**
 * @pattern ^(asc|desc)$
 */
order?: string;
};
